/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import "../../../css/tabViewCentered.css";
import InteractiveProposalSolutionInsights from "./ProposalSolutionSubTab.tsx/InsightsTab";
import ExperienceTab from "./ProposalSolutionSubTab.tsx/ExperienceTab";
import { THEME } from "app/utils/types";
import { getSessionStore } from "app/utils/sessionStore";
import CommentLayout from "app/uicomponents/macrocomponents/Comments/CommentLayout";
import VisualTab from "./ProposalSolutionSubTab.tsx/VisualsTab";
import { getThemeColors } from "app/utils/utils";
import VisulaIconIntRev from "app/assets/IconComponent/VisualIconIntRev";
import ExperieinceIconIntRev from "app/assets/IconComponent/ExperienceIconIntRev";
import { ShieldCheck } from "lucide-react";

const VisualIconComponent = ({ isActive }: { isActive: boolean }) => (
  <VisulaIconIntRev width="22" height="22" isActive={isActive} />
);

const InsightIcon = ({ isActive }: { isActive: boolean }) => {
  const iconColor = !isActive ? "#8A8AA3" : "#1E3A8A";

  return <ShieldCheck size={22} strokeWidth={2} color={iconColor} />;
};

const ExperienceIconComponent = ({ isActive }: { isActive: boolean }) => (
  <ExperieinceIconIntRev isActive={isActive} width="22" height="22" />
);
interface IInteractiveProposalSolution {
  isIntReactiveRevCent?: boolean;
}
const InteractiveProposalSolution: React.FC<IInteractiveProposalSolution> = ({
  isIntReactiveRevCent,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [globalTheme, setGlobalTheme] = useState<string>(getSessionStore("globalTheme"));
  const { branding } = getSessionStore("lookUpResponse");
  const { primaryColor, secondaryColor } = getThemeColors(branding);
  const isDarkTheme = globalTheme === THEME.DARK;

  useEffect(() => {
    const intervalId = setInterval(() => {
      const updatedTheme = getSessionStore("globalTheme");
      if (updatedTheme !== globalTheme) {
        setGlobalTheme(updatedTheme);
      }
    }, 200); // Check every second

    return () => {
      clearInterval(intervalId);
    };
  }, [globalTheme]);

  const tabs = [
    {
      label: "Visuals",
      icon: (isActive: boolean) => <VisualIconComponent isActive={isActive} />,
    },
    {
      label: "Insights",
      icon: (isActive: boolean) => <InsightIcon isActive={isActive} />,
    },
    {
      label: "Experience",
      icon: (isActive: boolean) => <ExperienceIconComponent isActive={isActive} />,
    },
  ];

  return (
    <CommentLayout
      commentLayoutId="interactive-proposal-solution "
      className={`border border-1 shadow-xl rounded-md h-[calc(100vh-111px)] ${
        isDarkTheme ? "dark-theme" : ""
      }`}
      style={
        {
          "--theme-primary-color": isDarkTheme ? secondaryColor : primaryColor,
          "--theme-inactive-color": "#8A8AA3",
        } as React.CSSProperties
      }
    >
      <div className="p-4">
        <h2 className="text-xl font-semibold mb-3 text-gray-700 conthrax-font">Solutions</h2>

        {/* Tabs and Content Container */}
        <div className="flex">
          {/* Tabs */}
          <div className="flex flex-col w-48 h-11rem gap-3 mr-4">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`tab-item flex rounded-md conthrax-font ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {typeof tab.icon === "string" ? (
                  <i className={`${tab.icon} mr-2`} />
                ) : (
                  tab.icon(activeIndex === index)
                )}
                {tab.label}
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="flex-1">
            <CommentLayout
              commentLayoutId={`interactive-proposal-solution-tab-${activeIndex}`}
              className="text-gray-700"
            >
              {activeIndex === 0 && <VisualTab />}
              {activeIndex === 1 && (
                <InteractiveProposalSolutionInsights isDarkTheme={isDarkTheme} />
              )}
              {activeIndex === 2 && <ExperienceTab isIntReactiveRevCent={isIntReactiveRevCent} />}
            </CommentLayout>
          </div>
        </div>
      </div>
    </CommentLayout>
  );
};

export default InteractiveProposalSolution;
